import Modal from '../Modal'
import Button from '../Button'
import { STEPS, stepIndex } from '../../utils/onboarding'

// After a save during set-up: add more here, or go on to the next step.
// `next` comes from useOnboardingStep().after: { step, finishing }.
export default function OnboardingContinuePrompt({ open, saved = 'Saved', another = 'Add another', next, onAddAnother, onNext }) {
  const step = next?.step
  const finishing = !step
  return (
    <Modal
      open={open}
      onClose={onAddAnother}
      title={saved}
      subtitle={finishing ? 'That was the last step.' : `Step ${stepIndex(step.id) + 1} of ${STEPS.length} is next: ${step.title}.`}
      size="sm"
      footer={(
        <>
          <Button variant="ghost" onClick={onAddAnother}>{another}</Button>
          <Button onClick={onNext}>{finishing ? 'Finish set-up' : `Next: ${step.title}`}</Button>
        </>
      )}
    >
      <p className="acc-modal-text">
        {finishing
          ? 'Add more here, or finish setting up. You can change any step later from Getting started.'
          : 'Add more here, or go on to the next step. You can come back to this page any time from Getting started.'}
      </p>
    </Modal>
  )
}
